'use client'

import { createContext, useContext } from 'react'

export const AlgoliaUserTokenContext = createContext<string | undefined>(
  undefined,
)

export const useAlgoliaUserToken = (): string | undefined =>
  useContext(AlgoliaUserTokenContext)
